var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ptlShell"
  }, [_c('HubHeader', {
    attrs: {
      "fixed": false
    }
  }), _c('div', {
    staticClass: "ptlBody"
  }, [_c('aside', {
    staticClass: "ptlSide"
  }, [_c('div', {
    staticClass: "sideHead"
  }, [_c('button', {
    staticClass: "brand",
    attrs: {
      "type": "button",
      "title": "프로토콜 목록으로 이동"
    },
    on: {
      "click": _vm.moveList
    }
  }, [_c('span', {
    staticClass: "brandText"
  }, [_vm._v("프로토콜")]), _c('span', {
    staticClass: "brandSub"
  }, [_vm._v("목록")])])]), _c('button', {
    staticClass: "newProtocolBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createProtocol
    }
  }, [_c('span', {
    staticClass: "btnCode"
  }, [_vm._v("+")]), _vm._v(" 새 프로토콜 ")]), _c('nav', {
    staticClass: "sideNav"
  }, [_c('p', {
    staticClass: "navLabel"
  }, [_vm._v("WORKSPACE")]), _c('button', {
    staticClass: "navItem",
    class: {
      on: _vm.isGate
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.moveList
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("01")]), _vm._v("프로토콜 목록")]), _c('button', {
    staticClass: "navItem",
    class: {
      on: _vm.isEditor
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isEditor && !_vm.recentProtocol
    },
    on: {
      "click": _vm.openRecentProtocol
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("02")]), _vm._v("최근 편집")]), _vm.isEditor && _vm.editorMode === 'edit' ? [_c('p', {
    staticClass: "navLabel"
  }, [_vm._v("프로토콜 관리")]), _c('button', {
    staticClass: "navItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('connect');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("03")]), _vm._v("공정도 연결")]), _c('button', {
    staticClass: "navItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('publish');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("04")]), _vm._v("공개 설정")]), _c('button', {
    staticClass: "navItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('docOption');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("05")]), _vm._v("문서설정")]), _c('p', {
    staticClass: "navLabel"
  }, [_vm._v("편집")]), _c('button', {
    staticClass: "navItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('preview');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("06")]), _vm._v("미리보기")]), _c('button', {
    staticClass: "navItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('readonly');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("07")]), _vm._v("읽기모드 전환")]), _c('button', {
    staticClass: "navItem saveItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('save');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("08")]), _vm._v("저장")])] : _vm._e(), _vm.isEditor && _vm.editorMode === 'readonly' && _vm.editorAuth ? [_c('p', {
    staticClass: "navLabel"
  }, [_vm._v("프로토콜 관리")]), _vm.editorProtocolType !== 'UNIT' ? _c('button', {
    staticClass: "navItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('utilizeList');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("03")]), _vm._v("연결관리")]) : _vm._e(), _c('button', {
    staticClass: "navItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('editMode');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("04")]), _vm._v("수정모드 전환")]), _c('button', {
    staticClass: "navItem",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.runEditorAction('docInfo');
      }
    }
  }, [_c('span', {
    staticClass: "idx"
  }, [_vm._v("05")]), _vm._v("문서정보")])] : _vm._e()], 2), _c('div', {
    staticClass: "sideFoot"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.moveHome
    }
  }, [_vm._v("메인")]), _c('span', {
    staticClass: "sep"
  }), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.moveMypage
    }
  }, [_vm._v("마이페이지")]), _c('span', {
    staticClass: "sep"
  }), _c('a', {
    attrs: {
      "href": "/m3dhub/tutorial/Hub_Manual.pdf",
      "target": "_blank"
    }
  }, [_vm._v("매뉴얼")])])]), _c('main', {
    staticClass: "ptlMain"
  }, [_c('router-view', {
    key: _vm.routeViewKey
  })], 1)]), _c('registDictionaryPopup', {
    key: _vm.registDictionaryPopupKey,
    attrs: {
      "forceReRender": _vm.registDictionaryPopupKey
    },
    on: {
      "update:forceReRender": function ($event) {
        _vm.registDictionaryPopupKey = $event;
      },
      "update:force-re-render": function ($event) {
        _vm.registDictionaryPopupKey = $event;
      }
    }
  }), _c('TagOptionPopTagAddList'), _c('ExperimentType'), _c('EditAttribute'), _c('EditAttributePool'), _c('ConnectProtocol'), _c('SearchProtocol'), _c('ProtocolDetail'), _c('FileUpload')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }